module.exports = __webpack_public_path__ + "static/media/etude-exploratoire-internationnale-sur-les-routines-beautes-des-femmes-mini.59ec30c9.jpg";